/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ERC1155PresetMinterPauser,
  ERC1155PresetMinterPauserInterface,
} from "../ERC1155PresetMinterPauser";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "uri",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAUSER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "burnBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "mintBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type ERC1155PresetMinterPauserConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERC1155PresetMinterPauserConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERC1155PresetMinterPauser__factory extends ContractFactory {
  constructor(...args: ERC1155PresetMinterPauserConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "ERC1155PresetMinterPauser";
  }

  deploy(
    uri: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC1155PresetMinterPauser> {
    return super.deploy(
      uri,
      overrides || {}
    ) as Promise<ERC1155PresetMinterPauser>;
  }
  getDeployTransaction(
    uri: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(uri, overrides || {});
  }
  attach(address: string): ERC1155PresetMinterPauser {
    return super.attach(address) as ERC1155PresetMinterPauser;
  }
  connect(signer: Signer): ERC1155PresetMinterPauser__factory {
    return super.connect(signer) as ERC1155PresetMinterPauser__factory;
  }
  static readonly contractName: "ERC1155PresetMinterPauser";
  public readonly contractName: "ERC1155PresetMinterPauser";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC1155PresetMinterPauserInterface {
    return new utils.Interface(_abi) as ERC1155PresetMinterPauserInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC1155PresetMinterPauser {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ERC1155PresetMinterPauser;
  }
}
